const WorkspacePlaceholder = () => import("@/views/my-test/teacher/WorkspacePlaceholder.vue");

// 교사 나의 검사 관리 — WorkspaceLayout(업무용 헤더 + LNB) 아래에 둔다 (router/index.js)
// 메뉴 구조는 src/config/workspace.js 의 WORKSPACE_MENU 와 맞춘다
export const myTestWorkspaceRoutes = [
  // 학생 나의 검사 관리: 업무용 헤더 + LNB(시험 카드 · 응시하기 · 검사 결과)
  {
    path: "/my-test/student",
    name: "MyTestStudent",
    component: () => import("@/views/my-test/student/index.vue"),
    meta: { title: "나의 검사 - 학생 검사 관리" },
    children: [
      {
        path: "apply",
        name: "MyTestStudentApply",
        component: () => import("@/views/my-test/student/ApplyExam.vue"),
        meta: { title: "나의 검사 - 응시하기" },
      },
      {
        path: "result",
        name: "MyTestStudentResult",
        component: () => import("@/views/my-test/student/ExamResult.vue"),
        meta: { title: "나의 검사 - 검사 결과" },
      },
    ],
  },
  {
    path: "/my-test/teacher",
    name: "MyTestTeacher",
    component: () => import("@/views/my-test/teacher/index.vue"),
    meta: { title: "나의 검사 - 교사 검사 관리" },
    children: [
      {
        // 구성원 관리: 업무 헤더 상단 메뉴(학교관리자 전용) — 시험과 무관해 LNB 없이 표시
        path: "manage-members",
        name: "MyTestTeacherManageMember",
        component: () => import("@/views/my-test/teacher/ManageMember.vue"),
        meta: { title: "구성원 관리", requiresSchoolAdmin: true, wsTopMenu: "members", wsBare: true },
      },
      {
        path: "manage-members/:tabId(\\d+)",
        name: "MyTestTeacherManageMemberWithTab",
        component: () => import("@/views/my-test/teacher/ManageMember.vue"),
        meta: { title: "구성원 관리", requiresSchoolAdmin: true, wsTopMenu: "members", wsBare: true },
      },
      {
        // 시험 계획: 기존 진단검사 접수 통합 (학교관리자는 접수 화면, 그 외 교사는 일정 화면)
        path: "plan",
        name: "MyTestTeacherPlan",
        component: () => import("@/views/my-test/teacher/ExamPlan.vue"),
        meta: { title: "나의 검사 - 시험 계획" },
      },
      {
        // 기존 진단검사 접수 경로(메인 일정 카드 [접수하기] 등)는 시험 계획으로 보낸다
        path: "register-exam",
        name: "MyTestTeacherRegisterExam",
        redirect: { name: "MyTestTeacherPlan" },
      },
      {
        path: "items",
        name: "MyTestTeacherItems",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 문항 관리" },
      },
      {
        path: "rehearsal/proctor",
        name: "MyTestTeacherRehearsalProctor",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 시험감독 체험하기" },
      },
      {
        path: "rehearsal/student",
        name: "MyTestTeacherRehearsalStudent",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 학생 응시 체험하기" },
      },
      {
        path: "rehearsal/grading",
        name: "MyTestTeacherRehearsalGrading",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 채점 체험하기" },
      },
      {
        path: "pre-check",
        name: "MyTestTeacherPreCheck",
        component: () => import("@/views/my-test/teacher/PreCheck.vue"),
        meta: { title: "나의 검사 - 사전 점검", wsBare: true },
      },
      {
        path: "pre-check-paper",
        name: "MyTestTeacherPreCheckPaper",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 사전 점검(종이 기반 평가)" },
      },
      {
        path: "watch",
        name: "MyTestTeacherWatch",
        component: () => import("@/views/my-test/teacher/ExamWatch.vue"),
        meta: { title: "나의 검사 - 시험 감독", wsBare: true },
      },
      {
        // 채점관리: 레이아웃(검사 선택 + 탭바)이 공통 상태를 보유하고
        // 각 탭은 child route 로 분리되어 별도 URL 을 가진다.
        path: "grading",
        component: () => import("@/views/my-test/teacher/GradingManage.vue"),
        meta: { title: "나의 검사 - 채점관리", requiresGradingAccess: true },
        children: [
          {
            // /grading 기본 진입: 특정 탭으로 하드코딩하지 않는다.
            // GradingManage.vue 가 역할에 맞는 노출 탭을 계산해 첫 탭으로 이동시킨다
            // (권한별로 첫 탭이 다르므로 라우터 레벨에서 고정된 탭으로 보낼 수 없다).
            path: "",
            name: "MyTestTeacherGrading",
          },
          {
            path: "grader",
            name: "MyTestTeacherGradingGrader",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/GraderRegistrationTab.vue"),
            meta: { title: "나의 검사 - 채점자 등록", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "notice",
            name: "MyTestTeacherGradingNotice",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/NoticeGraderTab.vue"),
            meta: { title: "나의 검사 - 공지사항", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "criteria",
            name: "MyTestTeacherGradingCriteria",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/GradingCriteriaTab.vue"),
            // wsBare: 검색·대시보드·목록 카드를 화면이 직접 구성 (리뉴얼 시안)
            meta: { title: "나의 검사 - 채점 기준 설정", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "first",
            name: "MyTestTeacherGradingFirst",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/FirstGradingTab.vue"),
            meta: { title: "나의 검사 - 1차 채점", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "second",
            name: "MyTestTeacherGradingSecond",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/SecondGradingTab.vue"),
            meta: { title: "나의 검사 - 2차 채점", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "feedback",
            name: "MyTestTeacherGradingFeedback",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/FeedbackRegistrationTab.vue"),
            meta: { title: "나의 검사 - 채점 결과 확인", requiresGradingAccess: true, wsBare: true },
          },
          {
            path: "leader",
            name: "MyTestTeacherGradingLeader",
            component: () =>
              import("@/components/my-test/teacher/grading-manage/LeaderManageTab.vue"),
            meta: { title: "나의 검사 - 채점 운영", requiresGradingAccess: true, wsBare: true },
          },
        ],
      },
      {
        // /grading 하위가 아닌 별도 경로 (채점관리 탭 레이아웃 GradingManage 를 타지 않도록)
        path: "grading-paper",
        name: "MyTestTeacherGradingPaper",
        component: WorkspacePlaceholder,
        meta: { title: "나의 검사 - 채점 관리(종이 기반 평가)", requiresGradingAccess: true },
      },
      {
        path: "grading/education-answer-select",
        name: "MyTestTeacherEducationAnswerSelect",
        component: () => import("@/views/my-test/teacher/EducationAnswerSelect.vue"),
        // wsBare: 검색·대시보드·목록·답안 카드를 화면이 직접 구성 (리뉴얼 시안)
        meta: {
          title: "나의 검사 - 교육용 답안 선택",
          requiresGradingAccess: true,
          wsBare: true,
          wsTitle: "연습채점 답안 선택",
          wsDescription: "수집된 학생 답안을 살펴보고 교육·연수용으로 활용할 답안을 선택하세요.",
        },
      },
      {
        // 결과 관리: 기존 검사 결과 화면(ExamResult.vue)에 디자인 가이드 적용
        path: "result",
        name: "MyTestTeacherResult",
        component: () => import("@/views/my-test/teacher/ExamResult.vue"),
        meta: { title: "나의 검사 - 검사 결과", wsBare: true },
      },
    ],
  },
];

export default [
  {
    path: "/my-test",
    name: "MyTestGate",
    component: () => import("@/views/my-test/index.vue"),
    meta: { title: "나의 검사 관리" },
  },
];
